/* eslint react/prop-types: 0 */

import 'src/styles/app.sass'
import React from 'react'
import store, { dispatch } from 'src/store'
import { Provider } from 'react-redux'
import { onResize, subscribeToResize, loadForm, useRequestDemoScrollBehavior } from 'src/actions'

export const wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>
}

export const onInitialClientRender = () => {
  dispatch(onResize())
  dispatch(subscribeToResize())
  dispatch(loadForm())
  dispatch(useRequestDemoScrollBehavior())
}
